import { httpClient } from '../lib/http-client';
import { StatusTicket } from '../types';

/**
 * Service para gerenciamento de status de tickets
 */
export class StatusTicketsService {
  static async getStatusTickets(): Promise<StatusTicket[]> {
    return httpClient.get<StatusTicket[]>('/api/status-tickets');
  }

  static async getStatusTicket(id: number): Promise<StatusTicket> {
    return httpClient.get<StatusTicket>(`/api/status-tickets/${id}`);
  }

  static async createStatusTicket(data: Partial<StatusTicket>): Promise<StatusTicket> {
    return httpClient.post<StatusTicket>('/api/status-tickets', data);
  }

  static async updateStatusTicket(
    id: number,
    data: Partial<StatusTicket>
  ): Promise<StatusTicket> {
    return httpClient.put<StatusTicket>(`/api/status-tickets/${id}`, data);
  }

  static async deleteStatusTicket(id: number): Promise<{ success: boolean }> {
    return httpClient.delete<{ success: boolean }>(`/api/status-tickets/${id}`);
  }
}

